import { render, staticRenderFns } from "./predictionimg.vue?vue&type=template&id=1c8da1b9"
import script from "./predictionimg.vue?vue&type=script&lang=js"
export * from "./predictionimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports